import { default as _91_46_46_46slug_93pvGVZEAWcBMeta } from "/usr/src/app/pages/[...slug].vue?macro=true";
import { default as addToCartWqlDrs5HLOMeta } from "/usr/src/app/pages/addToCart.vue?macro=true";
import { default as articleList0G8CZp7meCMeta } from "/usr/src/app/pages/articleList.vue?macro=true";
import { default as listm6t0KPaNqNMeta } from "/usr/src/app/pages/bothersMe/list.vue?macro=true";
import { default as brandListShNPiTLTy2Meta } from "/usr/src/app/pages/brand/brandList.vue?macro=true";
import { default as cartStep1x1SRwC2ZBnMeta } from "/usr/src/app/pages/cart/cartStep1.vue?macro=true";
import { default as cartStep2_legacyj4AA9FM32pMeta } from "/usr/src/app/pages/cart/cartStep2_legacy.vue?macro=true";
import { default as cartStep2vgyPUj2MMgMeta } from "/usr/src/app/pages/cart/cartStep2.vue?macro=true";
import { default as cartStep3uKMDeVASKgMeta } from "/usr/src/app/pages/cart/cartStep3.vue?macro=true";
import { default as cartStep4mzD8jzC2sHMeta } from "/usr/src/app/pages/cart/cartStep4.vue?macro=true";
import { default as _6OYIWfxvddMeta } from "/usr/src/app/pages/category/_.vue?macro=true";
import { default as createComplaint0gOu6Qucp1Meta } from "/usr/src/app/pages/complaint/createComplaint.vue?macro=true";
import { default as homepagevIttuXxG96Meta } from "/usr/src/app/pages/complaint/homepage.vue?macro=true";
import { default as detail5cSb7PgsohMeta } from "/usr/src/app/pages/counselling/detail.vue?macro=true";
import { default as homepagezr6P8GHRmOMeta } from "/usr/src/app/pages/counselling/homepage.vue?macro=true";
import { default as list2KwbWktmZeMeta } from "/usr/src/app/pages/counselling/list.vue?macro=true";
import { default as detaildYd9xgitIDMeta } from "/usr/src/app/pages/detail.vue?macro=true";
import { default as emptyTwqVDykXHeMeta } from "/usr/src/app/pages/empty.vue?macro=true";
import { default as emptyNoLayoutPgD8EqihvtMeta } from "/usr/src/app/pages/emptyNoLayout.vue?macro=true";
import { default as emptyNoLayoutNoGTMzhJFXUIag6Meta } from "/usr/src/app/pages/emptyNoLayoutNoGTM.vue?macro=true";
import { default as formRecommendBdbRFu5N8gMeta } from "/usr/src/app/pages/formRecommend.vue?macro=true";
import { default as indexgw2ikJsyhcMeta } from "/usr/src/app/pages/index.vue?macro=true";
import { default as migraineQuestionnairewGthxUEkmiMeta } from "/usr/src/app/pages/migraineQuestionnaire.vue?macro=true";
import { default as migraineQuestionnaireResultvPFn3swvoNMeta } from "/usr/src/app/pages/migraineQuestionnaireResult.vue?macro=true";
import { default as paperAuthordy12kge36WMeta } from "/usr/src/app/pages/paperAuthor.vue?macro=true";
import { default as detailzQOktCWToLMeta } from "/usr/src/app/pages/pharmacy/detail.vue?macro=true";
import { default as list2E14W0I0hUMeta } from "/usr/src/app/pages/pharmacy/list.vue?macro=true";
import { default as boxDetailxqLNv3MjqgMeta } from "/usr/src/app/pages/pickupPlace/boxDetail.vue?macro=true";
import { default as detailICYU515G58Meta } from "/usr/src/app/pages/pickupPlace/detail.vue?macro=true";
import { default as glsDetail979rrqhm4cMeta } from "/usr/src/app/pages/pickupPlace/glsDetail.vue?macro=true";
import { default as listMtdDwqY2xBMeta } from "/usr/src/app/pages/pickupPlace/list.vue?macro=true";
import { default as postOfficeDetailNzMw8zbPGlMeta } from "/usr/src/app/pages/pickupPlace/postOfficeDetail.vue?macro=true";
import { default as pplDetailcjiOAemjNvMeta } from "/usr/src/app/pages/pickupPlace/pplDetail.vue?macro=true";
import { default as zasilkovnaDetailTQPgRkZb4KMeta } from "/usr/src/app/pages/pickupPlace/zasilkovnaDetail.vue?macro=true";
import { default as redirectPermanentozF5VWMgBiMeta } from "/usr/src/app/pages/redirectPermanent.vue?macro=true";
import { default as redirectToLegacyA4nKKagwhaMeta } from "/usr/src/app/pages/redirectToLegacy.vue?macro=true";
import { default as _C9WK7nOgIUMeta } from "/usr/src/app/pages/static/_.vue?macro=true";
import { default as staticSamplexAEkyhJ5sXMeta } from "/usr/src/app/pages/staticSample.vue?macro=true";
import { default as terminationQmxmk1JKXSMeta } from "/usr/src/app/pages/termination.vue?macro=true";
import { default as editProfileq6aS4JogMCMeta } from "/usr/src/app/pages/user/editProfile.vue?macro=true";
import { default as favoriteKbM64gy00GMeta } from "/usr/src/app/pages/user/favorite.vue?macro=true";
import { default as feedbackLFoLnKIOrBMeta } from "/usr/src/app/pages/user/feedback.vue?macro=true";
import { default as forgottenPasswordn5kkqMgTGTMeta } from "/usr/src/app/pages/user/forgottenPassword.vue?macro=true";
import { default as loginOXuNuqxJEXMeta } from "/usr/src/app/pages/user/login.vue?macro=true";
import { default as loginVerifywSqHAOfltlMeta } from "/usr/src/app/pages/user/loginVerify.vue?macro=true";
import { default as orderm2x1qtCtMJMeta } from "/usr/src/app/pages/user/order.vue?macro=true";
import { default as ordersmghRD5id0LMeta } from "/usr/src/app/pages/user/orders.vue?macro=true";
import { default as pilulkaProNu5uo64mQmMeta } from "/usr/src/app/pages/user/pilulkaPro.vue?macro=true";
import { default as pilulkaProCancelReasonBrCCptUo0vMeta } from "/usr/src/app/pages/user/pilulkaProCancelReason.vue?macro=true";
import { default as pilulkaProSaveOfferpqhUWsM3tsMeta } from "/usr/src/app/pages/user/pilulkaProSaveOffer.vue?macro=true";
import { default as profileckC0zuSrddMeta } from "/usr/src/app/pages/user/profile.vue?macro=true";
import { default as recommendAndEarnstSaiV1PD7Meta } from "/usr/src/app/pages/user/recommendAndEarn.vue?macro=true";
import { default as registrationGoe6img7KCMeta } from "/usr/src/app/pages/user/registration.vue?macro=true";
import { default as verifyEmailmkAAPtq5sLMeta } from "/usr/src/app/pages/user/verifyEmail.vue?macro=true";
import { default as userVoucherTestPZAgXrAvddMeta } from "/usr/src/app/pages/userVoucherTest.vue?macro=true";
import { default as vitodJv1JOHHvpMeta } from "/usr/src/app/pages/vito.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/usr/src/app/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "addToCart",
    path: "/addToCart",
    component: () => import("/usr/src/app/pages/addToCart.vue").then(m => m.default || m)
  },
  {
    name: "articleList",
    path: "/articleList",
    component: () => import("/usr/src/app/pages/articleList.vue").then(m => m.default || m)
  },
  {
    name: "bothersMe-list",
    path: "/bothersMe/list",
    component: () => import("/usr/src/app/pages/bothersMe/list.vue").then(m => m.default || m)
  },
  {
    name: "brand-brandList",
    path: "/brand/brandList",
    component: () => import("/usr/src/app/pages/brand/brandList.vue").then(m => m.default || m)
  },
  {
    name: "cart-cartStep1",
    path: "/cart/cartStep1",
    component: () => import("/usr/src/app/pages/cart/cartStep1.vue").then(m => m.default || m)
  },
  {
    name: "cart-cartStep2_legacy",
    path: "/cart/cartStep2_legacy",
    component: () => import("/usr/src/app/pages/cart/cartStep2_legacy.vue").then(m => m.default || m)
  },
  {
    name: "cart-cartStep2",
    path: "/cart/cartStep2",
    component: () => import("/usr/src/app/pages/cart/cartStep2.vue").then(m => m.default || m)
  },
  {
    name: "cart-cartStep3",
    path: "/cart/cartStep3",
    component: () => import("/usr/src/app/pages/cart/cartStep3.vue").then(m => m.default || m)
  },
  {
    name: "cart-cartStep4",
    path: "/cart/cartStep4",
    component: () => import("/usr/src/app/pages/cart/cartStep4.vue").then(m => m.default || m)
  },
  {
    name: "category-_",
    path: "/category/_",
    component: () => import("/usr/src/app/pages/category/_.vue").then(m => m.default || m)
  },
  {
    name: "complaint-createComplaint",
    path: "/complaint/createComplaint",
    component: () => import("/usr/src/app/pages/complaint/createComplaint.vue").then(m => m.default || m)
  },
  {
    name: "complaint-homepage",
    path: "/complaint/homepage",
    component: () => import("/usr/src/app/pages/complaint/homepage.vue").then(m => m.default || m)
  },
  {
    name: "counselling-detail",
    path: "/counselling/detail",
    component: () => import("/usr/src/app/pages/counselling/detail.vue").then(m => m.default || m)
  },
  {
    name: "counselling-homepage",
    path: "/counselling/homepage",
    component: () => import("/usr/src/app/pages/counselling/homepage.vue").then(m => m.default || m)
  },
  {
    name: "counselling-list",
    path: "/counselling/list",
    component: () => import("/usr/src/app/pages/counselling/list.vue").then(m => m.default || m)
  },
  {
    name: "detail",
    path: "/detail",
    component: () => import("/usr/src/app/pages/detail.vue").then(m => m.default || m)
  },
  {
    name: "empty",
    path: "/empty",
    component: () => import("/usr/src/app/pages/empty.vue").then(m => m.default || m)
  },
  {
    name: "emptyNoLayout",
    path: "/emptyNoLayout",
    component: () => import("/usr/src/app/pages/emptyNoLayout.vue").then(m => m.default || m)
  },
  {
    name: "emptyNoLayoutNoGTM",
    path: "/emptyNoLayoutNoGTM",
    component: () => import("/usr/src/app/pages/emptyNoLayoutNoGTM.vue").then(m => m.default || m)
  },
  {
    name: "formRecommend",
    path: "/formRecommend",
    component: () => import("/usr/src/app/pages/formRecommend.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/usr/src/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "migraineQuestionnaire",
    path: "/migraineQuestionnaire",
    component: () => import("/usr/src/app/pages/migraineQuestionnaire.vue").then(m => m.default || m)
  },
  {
    name: "migraineQuestionnaireResult",
    path: "/migraineQuestionnaireResult",
    component: () => import("/usr/src/app/pages/migraineQuestionnaireResult.vue").then(m => m.default || m)
  },
  {
    name: "paperAuthor",
    path: "/paperAuthor",
    component: () => import("/usr/src/app/pages/paperAuthor.vue").then(m => m.default || m)
  },
  {
    name: "pharmacy-detail",
    path: "/pharmacy/detail",
    component: () => import("/usr/src/app/pages/pharmacy/detail.vue").then(m => m.default || m)
  },
  {
    name: "pharmacy-list",
    path: "/pharmacy/list",
    component: () => import("/usr/src/app/pages/pharmacy/list.vue").then(m => m.default || m)
  },
  {
    name: "pickupPlace-boxDetail",
    path: "/pickupPlace/boxDetail",
    component: () => import("/usr/src/app/pages/pickupPlace/boxDetail.vue").then(m => m.default || m)
  },
  {
    name: "pickupPlace-detail",
    path: "/pickupPlace/detail",
    component: () => import("/usr/src/app/pages/pickupPlace/detail.vue").then(m => m.default || m)
  },
  {
    name: "pickupPlace-glsDetail",
    path: "/pickupPlace/glsDetail",
    component: () => import("/usr/src/app/pages/pickupPlace/glsDetail.vue").then(m => m.default || m)
  },
  {
    name: "pickupPlace-list",
    path: "/pickupPlace/list",
    component: () => import("/usr/src/app/pages/pickupPlace/list.vue").then(m => m.default || m)
  },
  {
    name: "pickupPlace-postOfficeDetail",
    path: "/pickupPlace/postOfficeDetail",
    component: () => import("/usr/src/app/pages/pickupPlace/postOfficeDetail.vue").then(m => m.default || m)
  },
  {
    name: "pickupPlace-pplDetail",
    path: "/pickupPlace/pplDetail",
    component: () => import("/usr/src/app/pages/pickupPlace/pplDetail.vue").then(m => m.default || m)
  },
  {
    name: "pickupPlace-zasilkovnaDetail",
    path: "/pickupPlace/zasilkovnaDetail",
    component: () => import("/usr/src/app/pages/pickupPlace/zasilkovnaDetail.vue").then(m => m.default || m)
  },
  {
    name: "redirectPermanent",
    path: "/redirectPermanent",
    component: () => import("/usr/src/app/pages/redirectPermanent.vue").then(m => m.default || m)
  },
  {
    name: "redirectToLegacy",
    path: "/redirectToLegacy",
    component: () => import("/usr/src/app/pages/redirectToLegacy.vue").then(m => m.default || m)
  },
  {
    name: "static-_",
    path: "/static/_",
    component: () => import("/usr/src/app/pages/static/_.vue").then(m => m.default || m)
  },
  {
    name: "staticSample",
    path: "/staticSample",
    component: () => import("/usr/src/app/pages/staticSample.vue").then(m => m.default || m)
  },
  {
    name: "termination",
    path: "/termination",
    meta: terminationQmxmk1JKXSMeta || {},
    component: () => import("/usr/src/app/pages/termination.vue").then(m => m.default || m)
  },
  {
    name: "user-editProfile",
    path: "/user/editProfile",
    component: () => import("/usr/src/app/pages/user/editProfile.vue").then(m => m.default || m)
  },
  {
    name: "user-favorite",
    path: "/user/favorite",
    component: () => import("/usr/src/app/pages/user/favorite.vue").then(m => m.default || m)
  },
  {
    name: "user-feedback",
    path: "/user/feedback",
    component: () => import("/usr/src/app/pages/user/feedback.vue").then(m => m.default || m)
  },
  {
    name: "user-forgottenPassword",
    path: "/user/forgottenPassword",
    component: () => import("/usr/src/app/pages/user/forgottenPassword.vue").then(m => m.default || m)
  },
  {
    name: "user-login",
    path: "/user/login",
    component: () => import("/usr/src/app/pages/user/login.vue").then(m => m.default || m)
  },
  {
    name: "user-loginVerify",
    path: "/user/loginVerify",
    component: () => import("/usr/src/app/pages/user/loginVerify.vue").then(m => m.default || m)
  },
  {
    name: "user-order",
    path: "/user/order",
    component: () => import("/usr/src/app/pages/user/order.vue").then(m => m.default || m)
  },
  {
    name: "user-orders",
    path: "/user/orders",
    component: () => import("/usr/src/app/pages/user/orders.vue").then(m => m.default || m)
  },
  {
    name: "user-pilulkaPro",
    path: "/user/pilulkaPro",
    component: () => import("/usr/src/app/pages/user/pilulkaPro.vue").then(m => m.default || m)
  },
  {
    name: "user-pilulkaProCancelReason",
    path: "/user/pilulkaProCancelReason",
    component: () => import("/usr/src/app/pages/user/pilulkaProCancelReason.vue").then(m => m.default || m)
  },
  {
    name: "user-pilulkaProSaveOffer",
    path: "/user/pilulkaProSaveOffer",
    component: () => import("/usr/src/app/pages/user/pilulkaProSaveOffer.vue").then(m => m.default || m)
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () => import("/usr/src/app/pages/user/profile.vue").then(m => m.default || m)
  },
  {
    name: "user-recommendAndEarn",
    path: "/user/recommendAndEarn",
    component: () => import("/usr/src/app/pages/user/recommendAndEarn.vue").then(m => m.default || m)
  },
  {
    name: "user-registration",
    path: "/user/registration",
    component: () => import("/usr/src/app/pages/user/registration.vue").then(m => m.default || m)
  },
  {
    name: "user-verifyEmail",
    path: "/user/verifyEmail",
    component: () => import("/usr/src/app/pages/user/verifyEmail.vue").then(m => m.default || m)
  },
  {
    name: "userVoucherTest",
    path: "/userVoucherTest",
    component: () => import("/usr/src/app/pages/userVoucherTest.vue").then(m => m.default || m)
  },
  {
    name: "vito",
    path: "/vito",
    component: () => import("/usr/src/app/pages/vito.vue").then(m => m.default || m)
  }
]